import React from 'react';

import { View, RadioGroupOption, RadioGroup } from '@gogame/components';
import { withFormField } from '@gogame/form';

const TypesRadioGroup = withFormField()(({ area, ...props }) => {
  const { data = {}, loading } = area || {};
  const mergedData = [...(data?.common || []), ...(data?.technical || [])];

  return (
    <View loading={loading}>
      <div style={{ minHeight: '72px' }}>
        <RadioGroup vertical={true} {...props}>
          {mergedData?.length
            ? mergedData.map(({ id, name }) => {
                return <RadioGroupOption key={id} value={id} label={name} />;
              })
            : null}
        </RadioGroup>
      </div>
    </View>
  );
});

export default TypesRadioGroup;
